import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    titleRoot: {
        paddingRight: theme.spacing(6),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    content: {
        minHeight: '10rem',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(2),
    },
}));

export const ScaleDetailDialog = ({ open, onClose, data }) => {
    const classes = useStyles();
    const titleId = 'scale-detail-dialog-title';

    const handleClose = () => {
        if (onClose) onClose();
    };

    const titleText = data?.name || 'Detalle';
    const detailText = data?.detail || 'No tiene detalle';

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={handleClose}
            aria-labelledby={titleId}
        >
            <DialogTitle id={titleId} disableTypography className={classes.titleRoot}>
                <Typography variant="h6">{titleText}</Typography>
                <IconButton
                    aria-label="Cerrar"
                    onClick={handleClose}
                    className={classes.closeButton}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent className={classes.content}>
                <Typography variant="body1" color="textPrimary">
                    {detailText}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained" color="primary">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
